export default  function Operations () {
    return(
        <div>
            Operations pages
        </div>
    )
}